import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { toast } from "react-toastify";

import ai from "../../../../helpers/axios";

const useCommissionEditor = ({ isOpen, tripId, section, initialForm, onSaved, onClose }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [form, setForm] = useState(initialForm);
  const [baseline, setBaseline] = useState(initialForm);
  const [salesReps, setSalesReps] = useState([]);
  const [repsLoading, setRepsLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setForm(initialForm);
    setBaseline(initialForm);
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!isOpen) return;

    let cancelled = false;

    const load = async () => {
      setRepsLoading(true);
      try {
        const token = await getAccessTokenSilently();
        const { data } = await ai.auth(token).get("/api/commissions");
        if (!cancelled) setSalesReps(data?.salesReps || []);
      } catch (error) {
        console.error("Error loading sales reps:", error);
        if (!cancelled) toast.error(error?.response?.data?.message || "Failed to load sales reps");
      } finally {
        if (!cancelled) setRepsLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [isOpen, getAccessTokenSilently]);

  const updateForm = (patch) => setForm((current) => ({ ...current, ...patch }));

  const dirty = JSON.stringify(form) !== JSON.stringify(baseline);

  const save = async (payload) => {
    setSaving(true);
    try {
      const token = await getAccessTokenSilently();
      const { data } = await ai.auth(token).put(`/api/trips/${tripId}/commission/${section}`, payload);
      toast.success("Changes saved");
      onSaved(data);
      onClose();
    } catch (error) {
      console.error("Error saving commission:", error);
      toast.error(error?.response?.data?.message || "Failed to save changes");
    } finally {
      setSaving(false);
    }
  };

  return { form, updateForm, dirty, salesReps, repsLoading, saving, save };
};

export default useCommissionEditor;
